import { Component, OnDestroy, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-unauthorized', // eslint-disable-line
  template: ''
})
export class UnauthorizedComponent implements OnInit, OnDestroy {
  constructor(
    private readonly loaderService: LoaderService,
    private readonly oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit() {
    this.loaderService.showGlobalLoader(true);

    this.oidcSecurityService.isAuthenticated$.subscribe(data => {
      if (data) {
        this.doCallbackLogicIfRequired();
      }
    });
  }

  // NOTE: keep this around for ngUnsubscribe AOT
  ngOnDestroy() {
    this.loaderService.hideGlobalLoader();
  }

  private doCallbackLogicIfRequired() {
    this.oidcSecurityService.authorize();
  }
}
